import { downloadFile, fetchCorsFile } from 'util/file'

async function buildShareData(url: string, link: string, origin?: string, file?: File): Promise<ShareData | undefined> {
  if (!url) return undefined
  if (!navigator.canShare) return undefined

  file ??= await fetchCorsFile(url)
  if (!file) return undefined

  const title = 'Try on'
  const files = [file]
  const share: ShareData = { title, url: link || url, files }

  if (navigator.canShare(share)) return share
  else return undefined
}

export async function shareMobile(url: string, link: string, origin?: string, file?: File): Promise<boolean> {
  try {
    const share = await buildShareData(url, link, origin, file)
    if (!share) return await downloadFile(url)
    await navigator.share(share)
    return true
  } catch (e: any) {
    // отмена системного диалога шеринга — не ошибка и не успех
    if (e?.name !== 'AbortError') console.error('share failed', e)
    return false
  }
}
